// extracted by mini-css-extract-plugin
export var actions = "_bz-d";
export var benefitCard = "_bz-a";
export var benefitIcon = "_bz-b";
export var benefitLabel = "_bz-c";
export var benefits = "_bz-9";
export var bodyText = "_bz-8";
export var closeButton = "_bz-2";
export var content = "_bz-3";
export var eyebrow = "_bz-4";
export var heading = "_bz-5";
export var image = "_bz-f";
export var imagePanel = "_bz-e";
export var modal = "_bz-0";
export var shell = "_bz-1";
export var title = "_bz-6";
export var titleOffer = "_bz-7";